var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 12,
    viewBox: "0 0 62 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M6.3421 0L7.99038 3.67003L11.8983 4.1459L9.00907 6.88997L9.77601 10.8541L6.3421 8.88L2.9082 10.8541L3.67514 6.88997L0.785933 4.1459L4.69383 3.67003L6.3421 0Z",
    fill: "#F99130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M18.7767 0L20.4249 3.67003L24.3328 4.1459L21.4436 6.88997L22.2106 10.8541L18.7767 8.88L15.3428 10.8541L16.1097 6.88997L13.2205 4.1459L17.1284 3.67003L18.7767 0Z",
    fill: "#F99130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M31.2112 0L32.8595 3.67003L36.7674 4.1459L33.8782 6.88997L34.6451 10.8541L31.2112 8.88L27.7773 10.8541L28.5443 6.88997L25.6551 4.1459L29.563 3.67003L31.2112 0Z",
    fill: "#F99130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 4",
    d: "M43.6448 0L45.2931 3.67003L49.201 4.1459L46.3118 6.88997L47.0787 10.8541L43.6448 8.88L40.2109 10.8541L40.9779 6.88997L38.0887 4.1459L41.9966 3.67003L43.6448 0Z",
    fill: "#F99130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 5",
    d: "M56.0784 0L57.7267 3.67003L61.6346 4.1459L58.7454 6.88997L59.5123 10.8541L56.0784 8.88L52.6445 10.8541L53.4115 6.88997L50.5223 4.1459L54.4302 3.67003L56.0784 0Z",
    fill: "#F99130"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroup);
export default __webpack_public_path__ + "static/media/stars-group.8c4265c136da915a83f0ba5578756053.svg";
export { ForwardRef as ReactComponent };